export default __webpack_public_path__ + "static/media/moss_manila_home.398e125c.png";